import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GeneralState } from './interfaces/general.state';
import { GENERAL_FEATURE_NAME } from './general.actions';
import { Locales } from '../enums/locales.enum';
import { columnsAliases } from './column-aliases/columns-aliases.selectors';
import { ColumnAlias } from './column-aliases/interfaces/column-alias.interface';

export const generalFeatureSelector = createSelector(
  createFeatureSelector<GeneralState>(GENERAL_FEATURE_NAME),
  state => state,
);

export const columnGroupsSelector = createSelector(
  generalFeatureSelector,
  state => state.columnGroups,
);

export const columnsSelector = createSelector(
  generalFeatureSelector,
  columnsAliases,
  (state, columnsAliases: ColumnAlias[]) => state.columnGroups ?
    Object.keys(state.columnGroups)
      .reduce((columns, groupKey) => {
        columns = columns.concat(state.columnGroups[groupKey].map(colId => {
          const alias = columnsAliases.find(alias => alias.attribute === colId);
          return { fieldKey: colId, fieldName: alias ? alias.alias : colId };
        }));
        return columns;
      }, []) : [],
);

export const customColumnsSelector = createSelector(
  generalFeatureSelector,
  state => {
    const columns = state.columnGroups;

    return [...columns['custom_int'], ...columns['custom_float'], ...columns['custom_str']];
  },
);

export const dataColumnNameSelector = (fieldKey: string) =>
  createSelector(
    columnsSelector,
    (columns) => columns
      .find(dataColumn => dataColumn.fieldKey === fieldKey)?.fieldName,
  );

export const gridColumnsSelector = createSelector(
  columnsSelector,
  columns => columns.map(col => ({
    colId: col.fieldKey,
    field: col.fieldKey,
    headerName: col.fieldName,
    pinned: null,
    sort: null,
  })),
);

export const generalColumns = createSelector(
  columnsSelector,
  columns => columns.map(col => ({
    id: col.fieldKey,
    order: null,
    pinned: null,
    sort: null,
  })),
);

export const langSelector = createSelector(
  generalFeatureSelector,
  state => state.lang,
);

export const mainMenuStateSelector = createSelector(
  generalFeatureSelector,
  state => state.sideBarOpened,
);

export const localeSelector = createSelector(
  generalFeatureSelector,
  state => {
    switch (state.lang) {
      case 'ua':
        return Locales.UA;
      case 'en':
        return Locales.EN;
      default:
        return Locales.EN;
    }
  },
);
